<template>
  <li class="base-card">
    <slot />
  </li>
</template>

<script>
export default {
  name: 'BaseCard',
};
</script>

<style scoped lang="scss">
.base-card {
  //border: solid 1px red;
  border-radius: 4px;
  box-shadow: 0 2px 4px #e2ebe9;

  transition: box-shadow 0.3s ease-in-out;

  &:hover {
    box-shadow: 0 6px 12px #e2ebe9;
  }
}
</style>
